import { cn } from '@/lib/utils';
import { Layers } from 'lucide-react';

import { useDashboardTitles } from '@/components/Dashboards/useDashboardTitles';

interface ArtifactInfo {
    elementId: string;
    filename: string;
    dashboardId?: string;
}

interface DMArtifactsProps {
    artifacts: ArtifactInfo[];
}

const DMArtifacts = ({ artifacts: rawArtifacts }: DMArtifactsProps) => {
    const dashboardTitles = useDashboardTitles(
        rawArtifacts.some((artifact) => artifact.dashboardId)
    );
    const artifacts = rawArtifacts.map((artifact) => ({
        ...artifact,
        filename:
            (artifact.dashboardId && dashboardTitles[artifact.dashboardId]) ||
            artifact.filename
    }));

    if (!artifacts.length) return null;

    const handleClick = () => {
        window.dispatchEvent(
            new CustomEvent('openArtifactsSidebar', {
                detail: { elementId: artifacts[0].elementId }
            })
        );
    };

    const title =
        artifacts.length === 1
            ? artifacts[0].filename
            : `${artifacts.length} Artifacts`;

    const subtitle =
        artifacts.length === 1
            ? 'Artifact'
            : artifacts.map((a) => a.filename).join(', ');

    return (
        <button
            onClick={handleClick}
            className={cn(
                'relative flex items-center w-full overflow-clip',
                'bg-card/25 border border-border rounded-lg p-4',
                'hover:bg-muted/50 transition-colors cursor-pointer',
                'text-left group'
            )}
        >
            <div className="flex flex-col min-w-0 grow">
                <span className="font-medium text-foreground text-base truncate leading-6">
                    {title}
                </span>
                <span className="max-w-[60%] text-muted-foreground text-sm truncate leading-5">
                    {subtitle}
                </span>
            </div>
            <div
                className={cn(
                    'top-4 right-16 absolute flex justify-center items-center',
                    'bg-background border border-foreground/20 dark:border-border rounded-lg p-4 pb-16',
                    'rotate-11 transition-transform duration-200 ease-linear',
                    'group-hover:rotate-6',
                    'group-hover:scale-105'
                )}
            >
                <Layers className="w-6 h-6 text-muted-foreground" />
            </div>
        </button>
    );
};

export default DMArtifacts;
